import { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { Box } from '@mui/material'

import Loading from 'components/global/Loading'
import useActions from '../use-actions'

const DirectoryCenter = () => {
  const {token} = useParams()
  const [searchParams] = useSearchParams()
  const { ssoCenter } = useActions()

  useEffect(() => {
    const betaOnlyAt = searchParams.get('beta_only_at')
    const redirectPath = betaOnlyAt !== null ? '/auth/me?beta_only_at=' : '/auth/me'
    ssoCenter(token, redirectPath)
      .then(() => {})
      .catch((error) => {
        console.error('SSO Center error:', error)
      })
  }, [])

  return (
    <Box
      width={'100%'}
      height={'100vh'}
      display={'flex'}
      alignItems={'center'}
      justifyContent="center"
    >
      <Loading />
    </Box>
  )
}

export default DirectoryCenter
